import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  FOOD_AND_DRINKS_ROUTE,
  SEAT_MAP_ROUTE,
  markRouteVisited,
} from './popupRouteVisits'

// Tracked centrally on route change rather than on each page's mount so a new
// entry path into these pages can't silently miss the flag.
const TRACKED_ROUTES = [FOOD_AND_DRINKS_ROUTE, SEAT_MAP_ROUTE]

export const useTrackPopupRouteVisits = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const visited = TRACKED_ROUTES.find(
      (route) => pathname === route || pathname.startsWith(`${route}/`),
    )
    if (visited) markRouteVisited(visited)
  }, [pathname])
}
